module.exports = __webpack_public_path__ + "static/media/linkDividing4.78967516.png";